import { I18nKeys } from 'i18n/keys';
import { defineMessages } from 'react-intl';

export const IdentityProvidersMessages = defineMessages({
  createIdentityProvider: {
    id: I18nKeys.IdentityProviderCreate,
    defaultMessage: 'Create identity provider',
  },
  selectExternalIdField: {
    id: I18nKeys.SelectExternalIdField,
    defaultMessage: 'Select External ID field ...',
  },
  selectUserType: {
    id: I18nKeys.SelectUserType,
    defaultMessage: 'Select user type ...',
  },
  nameRequiredError: {
    id: I18nKeys.IdentityProviderNameRequiredError,
    defaultMessage: 'Identity provider name is required',
  },
  certificatesRequiredError: {
    id: I18nKeys.IdentityProviderCertificatesRequiredError,
    defaultMessage: 'Certificates are required',
  },
  clientIdRequiredError: {
    id: I18nKeys.IdentityProviderClientIdRequiredError,
    defaultMessage: 'Client ID is required',
  },
  entityIdRequiredError: {
    id: I18nKeys.IdentityProviderEntityIdRequiredError,
    defaultMessage: 'Entity ID is required',
  },
  externalIdRequiredError: {
    id: I18nKeys.IdentityProviderExternalIdRequiredError,
    defaultMessage: 'External ID field is required',
  },
  userTypeRequiredError: {
    id: I18nKeys.IdentityProviderUserTypeRequiredError,
    defaultMessage: 'User type is required',
  },
  issuerRequiredError: {
    id: I18nKeys.IdentityProviderIssuerRequiredError,
    defaultMessage: 'Issuer is required',
  },
  ssoUrlRequiredError: {
    id: I18nKeys.SsoUrlIssuerRequiredError,
    defaultMessage: 'SSO url is required',
  },
  issuerUrlValidationError: {
    id: I18nKeys.IdentityProviderIssuerRequiredError,
    defaultMessage: 'Issuer should be a valid URL',
  },
  promptRequiredError: {
    id: I18nKeys.IdentityProviderPromptRequiredError,
    defaultMessage: 'Prompt is required',
  },
  rpEntityIdRequiredError: {
    id: I18nKeys.IdentityProviderRPEntityIdRequiredError,
    defaultMessage: 'RP entity ID is required',
  },
  setPrimary: {
    id: I18nKeys.SetPrimaryIdentityProvider,
    defaultMessage: 'Set Primary',
  },
  unsetPrimary: {
    id: I18nKeys.UnsetPrimaryIdentityProvider,
    defaultMessage: 'Unset Primary',
  },
});
